import { createRange } from "util/range";

export const VALID_RANGE = createRange(0, 1);
